<template>

  <div class="fakebody">
  <a class="card" href="https://magiceden.io/marketplace/sol_slugs">
    <div>
      <h3 class="card-h3">{{ symbol }}</h3>
      <h2 class="card-h2">{{ floorPrice }}</h2>
    </div>
    <!-- <span class="card-icon fas fa-rocket"></span> -->
    <!-- <p class="results">{{ data }}</p> -->
  </a>
  </div>
</template>

<script>
// import axios from "axios";
import WidgetMixin from '@/mixins/WidgetMixin';
import { widgetApiEndpoints } from '@/utils/defaults';

export default {
  mixins: [WidgetMixin],
  data() {
    return {
      symbol: null,
      floorPrice: null,
    };
  },
  computed: {
    endpoint() {
      return `${widgetApiEndpoints.magiceden}`;
    },
  },
  methods: {
    fetchData() {
      this.makeRequest(this.endpoint).then(this.processData);
    },
    processData(data) {
      // Do processing any here, and set component data
      // this.results = data;
      this.symbol = data.symbol;
      this.floorPrice = data.floorPrice / 1000000000;
    },
  },
};

</script>

<style lang="scss">
.results {
      text-transform: capitalize;
      font-size: 2rem;
      color: var(--widget-text-color);
}

.fakebody {
  display: grid;
  place-items: center;
  margin: 0;
  padding: 0;
  // background: #2c2d34;
}

.card-h2 {
  margin: 0;
  font-size: 3rem;
  // color: var(--item-text-color);
  color: #a0e54f;
}
.card-h3 {
    margin: 0;
  font-size: 1.5rem;
  // color: var(--item-text-color);
  color: var(--item-text-color);
}

.card {
  display: grid;
  align-items: center;
  grid-template-columns: auto 3.75rem;
  width: 13rem;
  padding: 1.5rem;
  border-radius: 0.75rem;
  // background: var(--item-background);
  text-decoration: none;
  // color: ;
}

.card-icon {
  display: grid;
  place-items: center;
  width: 3.75rem;
  height: 3.75rem;
  border-radius: 50%;
  background: var(--item-text-color);
  color: var(--item-group-heading-text-color-hover);
  font-size: 2rem;
}
</style>
